export default {
  detail: 'Merchant details',
  backpage: 'return to previous page',
  basic: 'merchant information',
  agency: 'agent',
  merchantkey: 'Merchant key',
  indetails: 'Merchant details',
  merchantcode: 'merchant Verify',
  scan: 'Scan the QR code to get the verification code input',
  authcode: 'please enter verification code',
  codenull: 'verification code must be filled',
  label: {
    amount: 'amount',
    merchatNo: 'MerchantNo',
    walletTypeTransferIn: 'TransferIn',
    walletTypeTransferOut: 'TransferOut',
    usdt_qr: 'USDT',
    walletTile: 'wallet details',
    all: 'Total wallet',
    kou: 'Manual deduction',
    recharge: 'Manual recharge',
    bank_online: 'online bank balance',
    bank_qr: 'BankQR balance',
    QR_TOP: 'QR_sun',
    QR_PRO: 'QR_PRO',
    zalo_transfer: 'zalo transfer',
    bank_transfer: 'Bank balance',
    card_pc: 'Telcos balance',
    card_zing: 'Zing balance',
    momo_fix_qr: 'Momo fix balance',
    payout: 'Payout',
    momo_qr: 'MomoQR balance',
    viettel_fix_qr: 'Viettelpay fix balance',
    viettel_qr: 'ViettelpayQR balance',
    zalo_qr: 'Zalopay balance',
    usdtBalance: 'USDT balance',
    qrProBalance: 'QRSun balance',
    viettelBalance: 'viettel balance',
    viettelFixBalance: 'viettel fix balance',
    zaloBalance: 'zalo balance',
    momoBalance: 'momo balance',
  },
  rules: {
    amount: {
      required: 'Amount cannot be empty',
      type: 'Amount must be a number',
      typeinteger: 'Amount must be a number,and must be an integer',
      max: 'The amount cannot be greater than the balance'
    },
    remark: {
      required: 'Remarks cannot be empty',
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/merchantdetails.js